import { Box, IconButton, Rating, Typography } from "@mui/material";
import React, { Fragment } from "react";
import AnalysisIco from "../../../../assets/icons/AnalysisIco";
import CandidateFitIco from "../../../../assets/icons/CandidateFitIco";
import ErrorCodeIco from "../../../../assets/icons/ErrorCodeIco";
import ExclamatoryIco from "../../../../assets/icons/ExclamatoryIco";
import NextStpeIco from "../../../../assets/icons/NextStepIco";
import StrengthIco from "../../../../assets/icons/StrengthIco";
import WeaknessIco from "../../../../assets/icons/WeaknessIco";
import { HandleSkeletion } from "../../../../utils/constants";
import { CustomDiv } from "../../../chat-bot/style";
import { CommonGrid2 } from "../../../common-components/StyledComponents";
import { CustomPaper } from "../../../resume-intelligence/Style";
import { CustomizeSpan, CustomUnOrderList } from "../../style";

function FeedbackCard({
  icon,
  message,
  marginBottom,
  background,
  border,
  title,
}) {
  return (
    <CustomPaper
      variant="outlined"
      width="100%"
      padding={"14px"}
      marginBottom={marginBottom}
      display={"flex"}
      alignItems={"start"}
      background={background}
      border={border}
      gap={"1rem"}
    >
      <CustomDiv>{icon}</CustomDiv>
      <CommonGrid2 display={"flex"} flexDirection={"column"} gap={"10px"}>
        <Typography fontSize={"17px"} fontWeight={600} color={"#00144A"}>
          {title}
        </Typography>
        <Typography fontSize={"15px"} fontWeight={500} color={"#00144A"}>
          {message}
        </Typography>
      </CommonGrid2>
    </CustomPaper>
  );
}

const RedFlag = ({
  icon,
  message,
  marginBottom,
  background,
  border,
  title,
}) => (
  <CustomPaper
    variant="outlined"
    width="100%"
    padding={"14px"}
    marginBottom={marginBottom}
    display={"flex"}
    alignItems={"start"}
    gap="1rem"
    background={background}
    border={border}
  >
    <CustomDiv>{icon}</CustomDiv>
    <CustomDiv>
      <Typography fontSize={"17px"} fontWeight={600}>
        {title}
      </Typography>
      <CustomUnOrderList
        padding="0px 0px 0px 25px"
        margin="10px 0px"
        gap="5px"
        fontSize="15px"
      >
        {message?.map((item, index) => (
          <li>{item}</li>
        ))}
      </CustomUnOrderList>
    </CustomDiv>
  </CustomPaper>
);

const StrengthWeak = ({
  icon,
  message,
  marginBottom,
  background,
  border,
  title,
  fontSize,
}) => (
  <CustomPaper
    variant="outlined"
    width="100%"
    padding={"14px"}
    marginBottom={marginBottom}
    display={"flex"}
    alignItems={"start"}
    gap="1rem"
    background={background}
    border={border}
    height="100%"
  >
    <CustomDiv>{icon}</CustomDiv>
    <CustomDiv>
      <Typography fontSize={"17px"} fontWeight={600}>
        {title}
      </Typography>
      <CustomUnOrderList
        padding="0px 0px 0px 15px"
        margin="10px 0px"
        gap="10px"
        fontSize={fontSize || "15px"}
      >
        {[
          ...(message || []).sort(
            (a, b) => (b?.rating ?? 0) - (a?.rating ?? 0)
          ),
        ].map((item, index) => (
          <li>
            <CustomizeSpan fontWeight="700">{item.category} : </CustomizeSpan>
            <Rating
              value={item?.rating}
              precision={0.5}
              readOnly
              sx={{
                color: "#FFA500",
                fontSize: "1rem",
                top: "3px",
                mr: 1,
              }}
            />
            {/* {item.justification} */}
          </li>
        ))}
      </CustomUnOrderList>
    </CustomDiv>
  </CustomPaper>
);

function Summary({
  matchedData,
  loading,
  handleQuestionMarkClick,
  iconVisible,
  chatBotData,
  checkWidth,
}) {
  return (
    <Box>
      {loading ? (
        <HandleSkeletion height={100} width={"100%"} marginRight={"1rem"} />
      ) : (
        <FeedbackCard
          message={matchedData?.insights?.feedback?.analysis}
          icon={<AnalysisIco />}
          marginBottom="16px"
          background="#EBF8FF"
          border="none !important"
          title={
            <CommonGrid2 display={"flex"} alignItems={"baseline"} gap={"1px"}>
              Analysis: Meets Expectations of Job Duties
              <IconButton
                onClick={() =>
                  handleQuestionMarkClick(
                    chatBotData.geminiBubble &&
                      chatBotData.geminiBubble.length !== 0
                      ? chatBotData.geminiBubble.filter(
                          (item) => item.question === "Candidate Accomplishment"
                        )[0]
                      : chatBotData.bubble.filter(
                          (item) => item.question === "Candidate Accomplishment"
                        )[0]
                  )
                }
                style={{ opacity: !iconVisible ? 0.5 : 1, marginTop: "-10px" }}
                disabled={!iconVisible}
              >
                <CandidateFitIco />
              </IconButton>
            </CommonGrid2>
          }
        />
      )}

      {/*  {loading ? (
        <HandleSkeletion height={100} width={"100%"} marginRight={"1rem"} />
      ) : (
        <Fragment>
          {matchedData?.insights?.feedback?.red_flags?.length !== 0 && (
            <RedFlag
              message={matchedData?.insights?.feedback?.red_flags}
              icon={<ExclamatoryIco size="30px" />}
              marginBottom="16px"
              background="#FFFAE3"
              border={"none !important"}
              title={"Red Flags"}
            />
          )}
        </Fragment>
      )}*/}

      {loading ? (
        <HandleSkeletion height={100} width={"100%"} marginRight={"1rem"} />
      ) : (
        <Fragment>
          {matchedData?.insights?.feedback?.recommendations?.length !== 0 && (
            <RedFlag
              message={matchedData?.insights?.feedback?.recommendations}
              icon={<NextStpeIco size="30px" />}
              marginBottom="16px"
              background="#F7F8F9"
              border={"none !important"}
              title={"Recommendations and Next Steps"}
            />
          )}
        </Fragment>
      )}

      <CommonGrid2 container spacing={2}>
        <CommonGrid2
          item
          size={{
            xs: 12,
            // md: checkWidth < 750 ? 12 : 6,
            // sm: 12,
          }}
        >
          {loading ? (
            <HandleSkeletion height={100} width={"100%"} marginRight={"1rem"} />
          ) : (
            <StrengthWeak
              message={matchedData?.insights?.strengths}
              icon={<StrengthIco size="30px" />}
              marginBottom="16px"
              background="#EBFFF2"
              border={"none !important"}
              title={"Strengths"}
              fontSize={"15px"}
            />
          )}
        </CommonGrid2>
        {/* <CommonGrid2
          item
          size={{
            xs: 12,
            md: checkWidth < 750 ? 12 : 6,
            sm: 12,
          }}
        >
          {loading ? (
            <HandleSkeletion height={100} width={"100%"} marginRight={"1rem"} />
          ) : (
            <StrengthWeak
              message={matchedData?.insights?.weaknesses}
              icon={<WeaknessIco size="30px" />}
              marginBottom="16px"
              background="#FFF7F0"
              border={"none !important"}
              title={"Weakness"}
              fontSize={"15px"}
            />
          )}
        </CommonGrid2> */}
      </CommonGrid2>

      {loading ? (
        <HandleSkeletion height={100} width={"100%"} marginRight={"1rem"} />
      ) : (
        <>
          {matchedData &&
            matchedData?.insights &&
            matchedData?.insights &&
            matchedData?.insights &&
            matchedData?.insights?.feedback &&
            matchedData?.insights &&
            matchedData?.insights?.feedback?.qm_errors && (
              <>
                <Typography
                  fontSize={"20px"}
                  fontWeight={600}
                  color={"#101828"}
                  marginBottom={"10px"}
                  marginTop={"1rem"}
                >
                  {"Data Error"}
                </Typography>

                {matchedData?.insights?.feedback?.qm_errors?.map(
                  (item, index) => (
                    <CustomPaper
                      variant="outlined"
                      width="100%"
                      padding={"12px"}
                      marginBottom={"10px"}
                      display={"flex"}
                      alignItems={"start"}
                      gap="14px"
                    >
                      <div>
                        <ErrorCodeIco />
                      </div>
                      <CommonGrid2
                        display={"flex"}
                        alignItems={"flex-start"}
                        gap={"4px"}
                        flexDirection={"column"}
                      >
                        <Typography
                          fontSize={"16px"}
                          fontWeight={700}
                          color={"#D80027"}
                        >
                          Error Code : {item.code}
                        </Typography>

                        <Typography
                          fontSize={"14px"}
                          fontWeight={500}
                          color={"#00144A"}
                        >
                          {item.message}
                        </Typography>
                      </CommonGrid2>
                    </CustomPaper>
                  )
                )}
              </>
            )}
        </>
      )}
    </Box>
  );
}

export default Summary;
